/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');
window.Vue = require('vue');
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

//引用es6语法插件
import "babel-polyfill";

//引用element分页组件
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
// Vue.use(ElementUI)
//按需引入element
import { Pagination, Message, Button, Tooltip, MessageBox, Dialog, Alert, InputNumber, Rate, Progress, Upload, Checkbox, CheckboxGroup } from 'element-ui';

Vue.use(Pagination);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Dialog);
Vue.use(Alert);
Vue.use(InputNumber);
Vue.use(Rate);
Vue.use(Progress);
Vue.use(Upload);
Vue.use(Checkbox);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);

Vue.prototype.$message = Message;
Vue.prototype.$MessageBox = MessageBox;

//引入jqueery
import $ from 'jquery'
Vue.prototype.$ = $

//引入i18n国际化插件
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
//注册i18n实例并引入语言文件
const i18n = new VueI18n({
    locale:localStorage.getItem('locale')|| $('#appjs').attr('default_language') || "English", // 用户若直接从弃单进入无法读取到local则使用当前主题默认语言
    messages: {
        English: require("../locales/en-US.json"),
        Chinese: require("../locales/zh-CN.json"),
        Spanish: require("../locales/sp-ES.json"),
        German: require("../locales/de-DE.json"),
        French: require("../locales/fr-FR.json"),
        Portuguese: require("../locales/pt-PT.json"),
        Italian: require("../locales/it-IT.json"),
    }
});
//引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)


//引入懒加载
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/optimumx/ls.optimumx';




//引入社交分享
var SocialSharing = require('vue-social-sharing');
window.Vue.use(SocialSharing);


//引入axios
import axios from 'axios'
Vue.prototype.$axios = axios
axios.interceptors.request.use(config => {
    let locale='en-US';
    switch (i18n.locale) {
        case 'Chinese':
            locale='zh-CN';
            break;
        case 'Spanish':
            locale='sp-ES';
            break;
        case 'German':
            locale='de-DE';
            break;
        case 'French':
            locale='fr-FR';
            break;
        case 'Portuguese':
            locale='pt-PT';
            break;
        case 'Italian':
            locale='it-IT';
            break;
        default:
            break;
    }
    config.headers['X-LANG'] = locale;
    return config;
  });
// 引入规范css
import 'normalize.css/normalize.css'


//引入vuex
import store from "./store/index.js"
// 模块自带组件
Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//公共组件
Vue.component('v-commoditylistitem', require('./components/common/commoditylistitem.vue').default);
Vue.component('v-commonfoot', require('./components/common/commonfoot.vue').default);
Vue.component('v-headtitle', require('./components/common/headtitle.vue').default);
Vue.component('v-line', require('./components/common/line.vue').default);
Vue.component('v-selectprice', require('./components/common/selectprice.vue').default);
Vue.component('v-noproduct', require('./components/common/noproduct.vue').default);
Vue.component('v-paypal', require('./components/common/paypal.vue').default);
Vue.component('v-saveprice', require('./components/common/saveprice.vue').default);
Vue.component('v-toptitle', require('./components/common/toptitle.vue').default);
Vue.component('v-subscribe', require('./components/common/subscribe.vue').default);
Vue.component('v-countdown', require('./components/common/countdown.vue').default);
//登录页面
Vue.component('v-login', require('./components/page/login.vue').default);
Vue.component('v-register', require('./components/page/register.vue').default);
//首页
Vue.component('v-index', require('./components/page/index.vue').default);
Vue.component('v-indexswiper', require('./components/view/index/indexswiper.vue').default);
Vue.component('v-indexswiperbtnbox', require('./components/view/index/indexswiperbtnbox.vue').default);

//最近售卖弹窗
Vue.component('v-lastsales', require('./components/view/lastsales/lastsales.vue').default);

//多语言切换
Vue.component('v-selectlang', require('./components/common/selectlang.vue').default)

//个人中心页面
Vue.component('v-accountbody', require('./components/view/account/accountbody.vue').default);
Vue.component('v-accountbodyaddress', require('./components/view/account/accountbodyaddress.vue').default);
Vue.component('v-accountbodyorder', require('./components/view/account/accountbodyorder.vue').default);
Vue.component('v-addressfrom', require('./components/view/account/addressfrom.vue').default);
Vue.component('v-accounttop', require('./components/view/account/accounttop.vue').default);
//搜索页面
Vue.component('v-search', require('./components/page/search.vue').default);
//购物车页面
Vue.component('v-cart', require('./components/page/cart.vue').default);
//商品列表页面
Vue.component('v-collections', require('./components/view/collections/collections.vue').default);
Vue.component('v-collectionitem', require('./components/view/collections/collectionitem.vue').default);
//商品详情页
Vue.component('v-commoditydetail', require('./components/page/commoditydetail.vue').default);
Vue.component('v-comments', require('./components/view/comments/comments.vue').default);
//checkout accordion
Vue.component('v-accordion', require('./components/view/checkout/accordion.vue').default);
Vue.component('v-addressformfoot', require('./components/view/checkout/addressformfoot.vue').default);
//checkout information
Vue.component('v-information', require('./components/view/checkout/information.vue').default);
Vue.component('v-expresscheckout', require('./components/view/checkout/expresscheckout.vue').default);
//checkout shipping
Vue.component('v-shipping', require('./components/view/checkout/shipping.vue').default);
//checkout noavailable
Vue.component('v-noavailable', require('./components/view/checkout/noavailable.vue').default);
//checkout payment
Vue.component('v-payment', require('./components/view/checkout/payment.vue').default);
// checkout thank
Vue.component('v-thank', require('./components/view/checkout/thank.vue').default);
//checkout rightshoppingcar
Vue.component('v-checkoutright', require('./components/view/checkout/checkoutright.vue').default);
//checkout rightshoppingcar
Vue.component('v-checkoutnav', require('./components/view/checkout/checkoutnav.vue').default);
//error 404
Vue.component('v-error404', require('./components/page/error404.vue').default);
// 货币符号
Vue.component('v-currencysymbol', require('./components/common/currencysymbol.vue').default);
// 支付图标
Vue.component('v-payicon', require('./components/common/payicon.vue').default);

// 引入公用方法挂入vue
import METHODS from './methods';
for (const key in METHODS) {
    if (METHODS.hasOwnProperty(key)) {
        Vue.prototype[key] = METHODS[key]
    }
}

// 引入Sentey
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
Sentry.init({
    dsn: process.env.MIX_SENTRY_DSN,
    release: process.env.MIX_VERSION,
    integrations: [new VueIntegration({ Vue, attachProps: true })]
    // beforeSend(event, hint) {
    //     const { response } = hint.originalException;
    //     if (response) {
    //       const { status, message } = response;
    //       if ((status && status === 404) || (message && message === 'Network Error')) {
    //         return null;
    //       }
    //     }
    //     return event;
    //   },
});
Sentry.configureScope((scope) => { scope.setTag("type", "store"); });
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
    el: '#app',
    store,
    i18n
});


